import { render, staticRenderFns } from "./ProductPage.vue?vue&type=template&id=236a5650&scoped=true&"
import script from "./ProductPage.vue?vue&type=script&lang=js&"
export * from "./ProductPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductPage.vue?vue&type=style&index=0&id=236a5650&prod&lang=scss&scoped=true&"
import style1 from "./ProductPage.vue?vue&type=style&index=1&id=236a5650&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a5650",
  null
  
)

export default component.exports